export function maskPhoneNumber(phoneNumber) {
  return phoneNumber.replace(/^(\+\d{4})\d+(\d{2})$/, '$1******$2')
}
